
import React, { PureComponent } from 'react'
import { Button, Row, Panel } from 'react-bootstrap'
import { reduxForm } from 'redux-form'
import { validateDate, validateDossierEconomic } from '../../../../util/validationFunctions'
import { dossierSubTypeId } from '../../../../constants/dossier/common/dossierSubType'
import { dossierTypes as dossierTypesConstant } from '../../../../constants/dossier/common/dossierTypes'
import { buttonsHeader } from '../../../../constants/dossier/common/buttonsHeader'
import CampaignsModal from '../../../dossiers/sales/campaings/CampaignsModal'
import EconomicPlan from '../../../dossiers/sales/EconomicPlan'
// import { formatMoney } from '../../../../util/utils'
import { saleTypeCodeEnum } from '../../../../constants/dossier/sale/saleType'

class EconomicFleetModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      disableClient: true,
      organizedUnit: null,
      dossierSubTypeId: null,
      changeCheckAll: false,
      dataId: null,
      actionId: null,
      sidebarConfiguration: null,
      showCampaignModal: false,
      campaignSelected: {},
      total: 0,
      openEconomicPanel: true
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.dirty && !this.props.haveEconomicChanges) {
      this.props.setHaveEconomicChanges(true)
    } else if (!this.props.dirty && this.props.haveEconomicChanges) {
      this.props.setHaveEconomicChanges(false)
    }

    if (this.props.resetForms && prevProps.resetForms !== this.props.resetForms) {
      this.closeEconomic()
    }
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (prevProps.showModal !== this.props.showModal) {
      if (this.props.fleet === null || this.props.fleet === undefined) {
        this.props.actions.clearEntity(-1, dossierSubTypeId.venta_vn)
      }

      this.setState({ disableClient: true, organizedUnit: null, dossierSubTypeId: null })
    }
    if (prevProps.showModal && !this.props.showModal) {
      this.closeEconomic()
    }

    if (prevProps.showModal !== this.props.showModal && this.props.showModal) {
      this.props.actions.fetchEconomicPlanCombos(this.props.fleet.organizedUnitId, this.props.fleet.dossierSubType)
      this.props.actions.getEconomicPlanPermissions(this.props.fleet.dossierSubType, this.props.fleet.organizedUnitId)
    }

    return null
  }

  collapsePanelEconomic () {
    this.setState({ openEconomicPanel: !this.state.openEconomicPanel })
  }

  updateComponentAfterDeleteAndRestart () {

  }

  validateDate (value, allValues, props) {
    const result = validateDate(value, props)
    return result === Object(result) ? undefined : result
  }

  simulate (values) {
    this.props.actions.simulateEconomicPlanFleet()
  }

  handleToUpdateComponent (component) {

  }

  toggleCampaignModal (value) {
    const priceModel = !isNaN(this.props?.economicPlanModal?.dossierEconomicComponent?.modelPriceAmount) ? this.props?.economicPlanModal?.dossierEconomicComponent.modelPriceAmount : 0
    if (!value || (value && priceModel > 0)) {
      this.setState({ showCampaignModal: value })
    } else {
      this.props.actions.openErrorMessageModal('DOSSIER_COMPONENTS.VALIDATIONS.REQUIRED_VEHICLE_PRICE')
    }
  }

  saveEconomicPlan (values, mode) {
    this.setEconomicForCalculate(values.dossierEconomicComponent, this.props.economicPlanModal?.dossierEconomicComponent)
    if (mode === 'save' && this.props.economicPlanModal?.dossierEconomicComponent.simulated) {
      this.updateEconomic()
    } else {
      this.simulate()
    }
  }

  setEconomicForCalculate (values, dossierEconomicComponent) {
    values.associatedCosts = dossierEconomicComponent.associatedCosts
    values.discounts = dossierEconomicComponent.discounts
    values.extraSales = dossierEconomicComponent.extraSales
    values.optionals = dossierEconomicComponent.optionals
    values.presents = dossierEconomicComponent.presents
    values.supplieds = dossierEconomicComponent.supplieds
    return values
  }

  createCampaign (values) {
    this.props.actions.addCampaign(values)
    this.toggleCampaignModal(false)
  }

  updateEconomic () {
    let dossierList = this.props.dossiers.map(x => { return x.dossierId })
    this.props.actions.setEconomicPlanFleetProcess(dossierList, () => { this.closeEconomic(); this.props.actions.openEconomicFleetModal(this.props.fleet, false, this.props.dossiers) })
  }

  getEconomicDataUpdate () {
    this.props.actions.setSimulatedFlag(false)
  }

  checkKeyDown (e) {
    if (e.key === 'Enter') e.preventDefault()
  }

  getCodeComissionSaleType () {
    const { dossierFleetDetails } = this.props
    if (dossierFleetDetails === null || dossierFleetDetails === undefined || dossierFleetDetails.length === 0) {
      return false
    }

    for (let i = 0; i < dossierFleetDetails.length; i++) {
      let saleCode = dossierFleetDetails[i].saleTypeCode
      if (saleCode !== saleTypeCodeEnum.AGENCY_MODEL_FLEET_WAGEN && saleCode !== saleTypeCodeEnum.AGENCY_MODEL_FLEET_SEAT && saleCode !== saleTypeCodeEnum.AGENCY_MODEL_PART_WAGEN && saleCode !== saleTypeCodeEnum.AGENCY_MODEL_PART_SEAT) {
        return false
      }
    }

    return true
  }

  closeEconomic () {
    this.props.actions.closeEconomicPlanModal()
    this.props.initialize({})
    this.props.reset()
    this.setState({
      disableClient: true,
      sidebarConfiguration: null,
      showCampaignModal: false,
      campaignSelected: {}
    })
  }

  modify () {
    this.props.moveToModifyEconomicSelection()
  }

  render () {
    const {
      t,
      handleSubmit, combos, change, economicPlanModal: { dossierEconomicComponent, economicFleetPermissions, campaignPermissions, editedCampaign, saleConfiguration },
      actions: {
        updateDiscount,
        createDiscount,
        deleteDiscount,
        updateOptional,
        createOptional,
        deleteOptional,
        updateComment,
        createComment,
        deleteComment,
        fetchCampaignEdition,
        updateCampaign,
        createCampaign,
        updateSupplied,
        createSupplied,
        deleteSupplied,
        updateExtraSale,
        createExtraSale,
        deleteExtraSale,
        deletePresent,
        updatePresent,
        createPresent,
        setActiveSection,
        openProcessingAgencyModal,
        openCommonModal,
        fetchSalesEconomic,
        updateAssociatedCosts,
        createAssociatedCosts,
        deleteAssociatedCosts,
        fetchDiscountModal,
        fetchAssociatedCostByPercentageModal,
        fetchProcessingAgencyModal,
        fetchAmountTaxModal,
        printDocumentaryWarranty,
        deleteEconomicCampaign,
        openCodeCommissionModal,
        changeCodeCommissionFleet
      }, dossierFleetDetails
    } = this.props
    const tKey = 'MANAGEMENT.FLEETS_TAB.'
    let title = t(`${tKey}FINANCIAL_ANALYSIS_TITLE`)
    let subTitle = t(`${tKey}NUM_SELECTED_DOSSIERS`).replace('##NUM_SELECTED##', this.props.dossiers ? this.props.dossiers.length : 0).replace('##NUM_TOTAL##', this.props.dossierFleetDetails ? this.props.dossierFleetDetails.length : 0)
    let bar = ' | '

    let combosCampaing = JSON.parse(JSON.stringify(combos))
    combosCampaing.dossierSubTypesCombo = combosCampaing.dossierSubTypesComboCampaign

    let totalAmountWithOptionals = (!isNaN(dossierEconomicComponent.modelPriceAmount) ? dossierEconomicComponent.modelPriceAmount : 0) + (!isNaN(dossierEconomicComponent.optionalTotalAmount) ? dossierEconomicComponent.optionalTotalAmount : 0)

    // let totalBill = dossierEconomicComponent.billTotalAmount ? dossierEconomicComponent.billTotalAmount : 0
    let organizedUnits = dossierFleetDetails ? dossierFleetDetails.map(x => x.organizedUnitId) : []
    const showCampaignPercentages = saleConfiguration?.showCampaignPercentages ?? false
    const showEconomicPlan = saleConfiguration?.showEconomicPlan ?? false

    if (!this.props.fleet) { return null } else {
      return (
        <div id="economicFleetModal">
          <CampaignsModal
            t={t}
            editedCampaign= {editedCampaign}
            showModal={this.state.showCampaignModal}
            campaignSelected={this.state.campaignSelected}
            vehicleAmount={totalAmountWithOptionals}
            combos={combosCampaing}
            componentConfiguration={campaignPermissions}
            actions={{
              closeModal: () => this.toggleCampaignModal(false),
              updateCampaign,
              createCampaign: (values) => this.createCampaign(values)
            }}
            secondClass = 'secondModal'
            showPercentages = {showCampaignPercentages && showEconomicPlan}
          />
          <div className="dossierGridPart-ComponentSection">
            <div className="header-panel  fleet-panel-box" onClick={() => this.collapsePanelEconomic()}>

              <div className="name-wrapper fleet-panel-box-title">
                <h4>{title}{bar}<span className='fleet-panel-subTitle'>{subTitle}</span></h4>
              </div>

              <i className={this.state.openEconomicPanel ? 'ico-arrow-black-down fleet-panel-box-caret' : 'ico-arrow-black-up fleet-panel-box-caret'} />
            </div>
            <Panel expanded={this.state.openEconomicPanel} onToggle={() => {}}>
              <Panel.Collapse>
                <div className="dossierGridPart-ComponentSection-Inner">
                  <Row className="flexInLine al-R">
                    <Button
                      id="economicFleet_check_all"
                      className="_Btn accept"
                      onClick = {() => this.props.selectAll()}
                      disabled={this.props.dossiers.length === this.props.dossierFleetDetails.length}>
                      {t('MANAGEMENT.FLEETS_TAB.CHECK_ALL')}
                    </Button>
                    <Button
                      id="economicFleet_modify_selection"
                      className="_Btn accept stk"
                      onClick = {() => this.modify()}>
                      {t('MANAGEMENT.FLEETS_TAB.MODIFY_SELECTION')}
                    </Button>
                    <Button
                      id="economicFleet_save"
                      className="_Btn new"
                      type="button"
                      onClick={handleSubmit((values) => this.saveEconomicPlan(values, 'save'))}
                      disabled={!dossierEconomicComponent.simulated}>
                      {t(`${tKey}SAVE`)}
                    </Button>
                  </Row>
                  <Row className='flexInLine al-R pad-y-15'>

                    <Button
                      id="economicFleet_add_campaign"
                      className="_Btn new"
                      onClick={() => this.toggleCampaignModal(true)} >
                      {t(`${tKey}ADD_CAMPAIGN`)}
                    </Button>
                    <Button
                      id="economicFleet_simulate"
                      className="_Btn accept"
                      type="button"
                      onClick={handleSubmit((values) => this.saveEconomicPlan(values, 'simulate'))}>
                      {t(`${tKey}SIMULATE`)}
                    </Button>
                  </Row>
                  <EconomicPlan
                    t={t}
                    pristine={true}
                    activeTab={buttonsHeader.planteo_economico}
                    dossierEconomicComponent={dossierEconomicComponent}
                    actions={{
                      updateDiscount,
                      createDiscount,
                      deleteDiscount,
                      updateOptional,
                      createOptional,
                      deleteOptional,
                      updateComment,
                      createComment,
                      deleteComment,
                      fetchCampaignEdition,
                      deleteEconomicCampaign,
                      updateCampaign,
                      createCampaign,
                      updateSupplied,
                      createSupplied,
                      deleteSupplied,
                      updateExtraSale,
                      createExtraSale,
                      deleteExtraSale,
                      deletePresent,
                      updatePresent,
                      createPresent,
                      setActiveSection,
                      openProcessingAgencyModal,
                      change,
                      openCommonModal,
                      fetchSalesEconomic,
                      updateAssociatedCosts,
                      createAssociatedCosts,
                      deleteAssociatedCosts,
                      fetchDiscountModal,
                      fetchProcessingAgencyModal,
                      fetchAssociatedCostByPercentageModal,
                      fetchAmountTaxModal,
                      printDocumentaryWarranty,
                      getEconomicDataUpdate: () => this.getEconomicDataUpdate(),
                      openCodeCommissionModal,
                      changeCodeCommission: changeCodeCommissionFleet
                    }}
                    readOnlyFields={false}
                    economicTab={true}
                    isFixed={true}
                    dossierType={dossierTypesConstant.fleetEconomicPlan}
                    activeStage={null}
                    combos={combos}
                    panelsPaddingTop={1}
                    tabConfiguration={this.state.sidebarConfiguration}
                    tabConfiguration2={economicFleetPermissions}
                    historical = {false}
                    isEconomicLoaded = {false}
                    handleToUpdateComponent = {this.handleToUpdateComponent.bind(this)}
                    dossierId={-1}
                    activeSection={this.props.activeSection}
                    dossierSubTypeId={this.props.fleet.dossierSubType}
                    codeCommissionSaleTypeShow = {this.getCodeComissionSaleType()}
                    organizedUnits={organizedUnits}
                  />
                </div>
              </Panel.Collapse>
            </Panel>
          </div>
        </div>
      )
    }
  }
}

const validate = (values, { t }, props) => {
  let errors = {}

  errors.dossierEconomicComponent = validateDossierEconomic(values.dossierEconomicComponent, t)
  return errors
}

export default reduxForm({
  form: 'economicPlanModal',
  validate

})(EconomicFleetModal)
